import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './About.css';

interface IAboutProps {
  title: React.ReactNode;
  description: React.ReactNode;
  regions: React.ReactNode;
  reliable: React.ReactNode;
  hasReliablePadding: boolean;
}

export function About({ title, description, regions, reliable, hasReliablePadding }: IAboutProps) {
  return (
    <section id="about" className={styles['about']}>
      <Layout>
        <div className={styles['container']}>
          <div className={styles['wrapper']}>
            <div className={styles['title']}>{title}</div>

            <div className={styles['description']}>{description}</div>

            {regions}
          </div>

          <div className={hasReliablePadding ? styles['reliable'] : undefined}>{reliable}</div>
        </div>
      </Layout>
    </section>
  );
}
